import { useAppSelector } from '@hooks/app/redux';
import { searchClients } from '@services/external/client.api';
import { useQuery, UseQueryOptions } from 'react-query';
import { IClientSearchParams } from 'types/client.types';

async function handler(providerId: string, params: IClientSearchParams) {
  const { data } = await searchClients(providerId, params);

  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function useClientSearch(
  params: IClientSearchParams,
  options?: UseQueryOptions<TQueryData, unknown, TQueryData, any[]>,
) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  return useQuery(
    ['clients:search', providerId, params, providerId],
    () => handler(providerId, params),
    options,
  );
}

export default useClientSearch;
